import styled, { css } from 'styled-components'

export const ModelsTitle = styled.h3`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.small};
    font-weight: ${theme.font.light};
    border-bottom: 1px solid ${theme.colors.xlightGray};
  `}
`

export const ModelsList = styled.li`
  ${({ theme }) => css`
    list-style: none;
    min-height: auto;
    max-height: 160px;
    overflow-y: scroll;

    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-thumb {
      background: ${theme.colors.primary};
      border-radius: 10px;
    }
  `}
`

export const ModelsListItem = styled.ul`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${theme.colors.xxlightGray};
    border-radius: ${theme.border.tooSmallRadius};
    font-size: ${theme.font.sizes.normal};
    font-weight: ${theme.font.normal};
    color: ${theme.colors.darkGray};
    padding: 10px;
    margin: 12px 0;
  `}
`

export const ModelsIconButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ModelsIconButton = styled.button`
  ${({ theme }) => css`
    background: transparent;
    cursor: pointer;

    > svg {
      width: 18px;
      height: 18px;

      path {
        fill: ${theme.colors.primary};
      }
    }

    .save-icon {
      path {
        fill: ${theme.colors.blue};
      }
    }

    .trash-icon {
      path {
        fill: ${theme.colors.red};
      }
    }
  `}
`

export const ModelsInputAndButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  > button {
    height: 48px;
    margin-top: 20px;
  }
`
